module.exports = __webpack_public_path__ + "img/11.bb69b06f.jpg";